/*
  Sent/List.js - Component to generate the list of Sent SMS items
*/

// NPM
import React, { useState, useEffect } from 'react';
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
} from '@mui/material';

// COMPONENTS
import CarrierReportsTableRow from './CarrierReportsTableRow';
import Paginator from '../../../components/common/Paginator';

// CONFIG
import config from '../../../Config';

// FORMATTED MESSAGES
import CarrierReportsFormattedMessages from '../../../messages/reports/CarrierReportsFormattedMessages';

const CarrierReportsTable = ({ list, showCarrierDetail, totals }) => {
  const [pageLength, setPageLength] = useState(config.defaultPL);
  const [pageNumber, setPageNumber] = useState(1);
  const [displayList, setDisplayList] = useState([]);
  const [count, setCount] = useState(list.length);

  /*
    Handles the change event when clicking a pagination number
  */
  const changeEvent = (i) => {
    setPageNumber(i);
  };

  const changePageLength = (e) => {
    const value = e.target.value;
    setPageLength(value);
    setPageNumber(1);
  };

  const handleList = () => {
    if (list && Array.isArray(list)) {
      const displayList = list.slice(
        (pageNumber - 1) * pageLength,
        (pageNumber - 1) * pageLength + pageLength
      );
      setDisplayList(displayList);
      setCount(list.length);
    } else {
      setCount(0);
      setDisplayList([]);
    }
  };

  useEffect(() => {
    handleList();
  }, [pageLength, pageNumber]);

  useEffect(() => {
    setPageNumber(1);
    handleList();
  }, [list]);

  const generateTableBody = () => {
    return displayList.map((element) => (
      <CarrierReportsTableRow
        key={element.carrier_name}
        id={element.carrier_name}
        carrierName={element.carrier_name}
        country={element.country_name}
        standardSent={element.messages_sent}
        directSent={element.direct_sent}
        reminderSent={element.reminders_sent}
        failedMessages={element.failed_messages}
        onClickCarrier={(e) => showCarrierDetail(e)}
        carrier={element}
      />
    ));
  };

  return (
    <>
      <TableContainer
        sx={{
          marginBottom: 4,
          overflowX: 'auto',
          width: '100%',
          whiteSpace: 'nowrap',
        }}
      >
        <Table id="inbox">
          <TableHead>
            <TableRow>
              <TableCell>
                {CarrierReportsFormattedMessages.carrierName}
              </TableCell>
              <TableCell>
                {CarrierReportsFormattedMessages.carrierCountry}
              </TableCell>
              <TableCell align="right">
                {CarrierReportsFormattedMessages.standardSent}
              </TableCell>
              <TableCell align="right">
                {CarrierReportsFormattedMessages.directSent}
              </TableCell>
              <TableCell align="right">
                {CarrierReportsFormattedMessages.reminderSent}
              </TableCell>
              <TableCell align="right">
                {CarrierReportsFormattedMessages.failedMessages}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {generateTableBody()}{' '}
            <TableRow>
              <TableCell>{CarrierReportsFormattedMessages.total}</TableCell>
              <TableCell></TableCell>
              <TableCell align="right">{totals.messages_sent}</TableCell>
              <TableCell align="right">{totals.direct_sent}</TableCell>
              <TableCell align="right">{totals.reminders_sent}</TableCell>
              <TableCell align="right">{totals.failed_messages}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <Paginator
        itemCount={count}
        changeEvent={changeEvent}
        pageLength={pageLength}
        pageNumber={pageNumber}
        editFunction={changePageLength}
      />
    </>
  );
};

export default CarrierReportsTable;
